const config = {
  domain:
    typeof window !== "undefined"
      ? `${window.location.protocol}//${window.location.host}`
      : "https://www.virtuaalikirkko.fi",
  cdn: process.env.NEXT_PUBLIC_VIDEOSYNC_CDN,
  imgResizer: process.env.NEXT_PUBLIC_IMAGERESIZER,
  vsyncUrl: process.env.VIDEOSYNC_URL,
  socketUrl: process.env.NEXT_PUBLIC_SOCKETIO_URL,
};

export default config;
